import { 
    ASYNC_NOMENCLATURE_CHANGE,
    ASYNC_NOMENCLATURE_CREATE,
    ASYNC_NOMENCLATURE_DELETE,
    ASYNC_NOMENCLATURE_DETAIL,
    ASYNC_NOMENCLATURE_LIST, NomenclatureItem, NomenclatureItemCreate,
    
} from "../../types"
import { ApiNomenclature } from "../../../../services";
import { 
    errorNomenclatureChange,
    errorNomenclatureCreate,
    errorNomenclatureDelete,
    errorNomenclatureDetail, 
    errorNomenclatureList, 
    fillNomenclatureChange, 
    fillNomenclatureCreate, 
    fillNomenclatureDelete, 
    fillNomenclatureDetail, 
    fillNomenclatureList, 
    startNomenclatureChange, 
    startNomenclatureCreate, 
    startNomenclatureDelete, 
    startNomenclatureDetail, 
    startNomenclatureList, 
    stopNomenclatureChange, 
    stopNomenclatureCreate, 
    stopNomenclatureDelete, 
    stopNomenclatureDetail, 
    stopNomenclatureList 
} from "../../actions";
import { makeRequestWithSpinner } from "../../../../worker";

type ActionNomenclatureList = {
    type: typeof ASYNC_NOMENCLATURE_LIST;
}

type ActionNomenclatureDetail = {
    type: typeof ASYNC_NOMENCLATURE_DETAIL;
    payload: {id: number}
}

type ActionNomenclatureDelete = {
    type: typeof ASYNC_NOMENCLATURE_DELETE;
    payload: {id: number}
}

type ActionNomenclatureCreate = {
    type: typeof ASYNC_NOMENCLATURE_CREATE;
    payload: NomenclatureItemCreate
}

type ActionNomenclatureChange = {
    type: typeof ASYNC_NOMENCLATURE_CHANGE;
    payload: NomenclatureItem
}

export function* fetchNomenclatureList (action: ActionNomenclatureList): Generator {
    try {
        const options = {
            fetcher: ApiNomenclature.getNomenclatureList,
            startFetching: startNomenclatureList,
            stopFetching: stopNomenclatureList,
            fill: fillNomenclatureList,
            setErrorAction: errorNomenclatureList,

        }

        yield makeRequestWithSpinner<{data: NomenclatureItem[]}, void>(options)
    } catch(e) {
        
    }
}


export function* fetchNomenclatureDetail (action: ActionNomenclatureDetail): Generator {
    try {
        const options = {
            fetcher: ApiNomenclature.getNomenclatureDetail,
            startFetching: startNomenclatureDetail,
            stopFetching: stopNomenclatureDetail,
            fill: fillNomenclatureDetail,
            setErrorAction: errorNomenclatureDetail,
            fetcherParam: action.payload
        }

        yield makeRequestWithSpinner<NomenclatureItem, ActionNomenclatureDetail['payload']>(options)
    } catch(e) {
        
    }
}


export function* fetchNomenclatureDelete (action: ActionNomenclatureDelete): Generator {
    try {
        const options = {
            fetcher: ApiNomenclature.deleteNomenclature,
            startFetching: startNomenclatureDelete,
            stopFetching: stopNomenclatureDelete,
            fill: fillNomenclatureDelete,
            setErrorAction: errorNomenclatureDelete,
            fetcherParam: action.payload
        }

        yield makeRequestWithSpinner<void, ActionNomenclatureDelete['payload']>(options)
    } catch(e) {
        
    }
}


export function* fetchNomenclatureCreate (action: ActionNomenclatureCreate): Generator {
    try {
        const options = {
            fetcher: ApiNomenclature.createNomenclature,
            startFetching: startNomenclatureCreate,
            stopFetching: stopNomenclatureCreate,
            fill: fillNomenclatureCreate,
            setErrorAction: errorNomenclatureCreate,
            fetcherParam: action.payload
        }

        yield makeRequestWithSpinner<void, ActionNomenclatureCreate['payload']>(options)
    } catch(e) {
        
    }
}


export function* fetchNomenclatureChange (action: ActionNomenclatureChange): Generator {
    try {
        const options = {
            fetcher: ApiNomenclature.changeNomenclature,
            startFetching: startNomenclatureChange,
            stopFetching: stopNomenclatureChange,
            fill: fillNomenclatureChange,
            setErrorAction: errorNomenclatureChange,
            fetcherParam: action.payload
        }

        yield makeRequestWithSpinner(options);
    } catch(e) {
        
    }
}